import {Middleware, type SerializableStateInvariantMiddlewareOptions} from '@reduxjs/toolkit'

import {browserConfirm, browserEventEmitter} from '@web/middlewares/browserEventEmitter'

import authMiddleware from './authMiddleware'
import orderInterruptedMiddleware from './orderInterruptedMiddleware'
import sentryTransaction from './sentryMiddleware'

export const DefaultMiddlewareOptions: {
    serializableCheck: SerializableStateInvariantMiddlewareOptions
} = {
    serializableCheck: {
        ignoredActions: [browserConfirm.type],
    },
}

const Middlewares: Middleware[] = [authMiddleware, orderInterruptedMiddleware, browserEventEmitter, sentryTransaction]

export default Middlewares
